import React from "react";
import {Link} from "react-router-dom";

export function URL({ children, href, ...params }) {
    return <Link to={href} {...params}>{children}</Link>
}
